var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.collection.banner_image_url)?_c('div',{staticClass:"mb-8"},[_c('img',{staticClass:"w-full object-cover opacity-50 object-center",staticStyle:{"height":"130px"},attrs:{"src":_vm.collection.banner_image_url}})]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }